import {UIMPopupPlayerSearchView} from '../../../../ui_popup/UIMPopupPlayerSearchView.ts'
import {setElementOnClick} from '../../../../../../shared/scripts/ui_utils/DomUtils.ts'

export class UIMLeaderboardSearchController {
    private readonly onSearchChange: (searchValue: string) => undefined
    private readonly searchButton: HTMLDivElement
    private readonly clearSearchButton: HTMLDivElement

    constructor(onSearchChange: (searchValue: string) => undefined) {
        this.onSearchChange = onSearchChange
        this.searchButton = document.getElementById('m-leaderboard_tabs_search') as HTMLDivElement
        this.clearSearchButton = document.getElementById('m-leaderboard_tabs_clear_search') as HTMLDivElement

        setElementOnClick(this.searchButton, () => {
            new UIMPopupPlayerSearchView((searchValue: string) => this.onSearchUpdate(searchValue))
        })

        setElementOnClick(this.clearSearchButton, () => {
            onSearchChange('')
            this.searchButton.style.display = ''
            this.clearSearchButton.style.display = 'none'
        })
    }

    private onSearchUpdate(searchValue: string) {
        this.onSearchChange(searchValue)
        this.searchButton.style.display = 'none'
        this.clearSearchButton.style.display = ''
    }
}
